export const CHANGE_SECOND_PANEL_VIEW = 'CHANGE_SECOND_PANEL_VIEW';
export const CHANGE_THIRD_PANEL_VIEW = 'CHANGE_THIRD_PANEL_VIEW';
export const CHANGE_FOURTH_PANEL_VIEW = 'CHANGE_FOURTH_PANEL_VIEW';
export const TOGGLE_THREAD_CONVERSATION_VIEW = 'TOGGLE_THREAD_CONVERSATION_VIEW';
export const TOGGLE_DIMMED_MODAL = 'TOGGLE_DIMMED_MODAL';
